<template>
<Form
	class="m-0 p-0 g-0"
	@submit="onSubmit"
	@invalid-submit="console.log"
	:validation-schema="schema"
	:initial-values="formValues"
	v-slot="{ errors, values, meta, isSubmitting }"
>
<fieldset class="" :disabled="!isFormEnabled">
	<div style="display: none;">
		{{ formMeta = meta }}
		{{ isSubmittingForm = isSubmitting }}
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6 mt-0">
			<label>IP адреса станції</label>
			<Field
				:name="Station.passportKeys.ip"
				type="text"
				class="form-control form-control-sm"
				:class="{ 'is-invalid': errors[Station.passportKeys.ip] }"
			/>
			<div class="invalid-feedback">
				{{errors[Station.passportKeys.ip]}}
			</div>
		</div>

		<div class="col-12 col-xl-6">
			<div class="bg-body border-radius px-3 py-2">
				<span class="form-text fst-italic">
					За такою IP-адресою будуть опитуватись всі модулі станції
				</span>
			</div>
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6">
			<div class="row">
				<div class="col-10">
					<label>Період опитування станції</label>
					<Field
						:name="Station.passportKeys.surveyPeriod"
						type="number"
						class="form-control form-control-sm no-arrow"
						:class="{ 'is-invalid': errors[Station.passportKeys.surveyPeriod] }"
					/>
					<div class="invalid-feedback">
						{{errors[Station.passportKeys.surveyPeriod]}}
					</div>
				</div>

				<div class="col-2">
					<label>&nbsp;</label>
					<Field
						name="surveyPeriodMultiplier"
						as="select"
						class="form-control form-control-sm"
					>
						<option value="1">c</option>
						<option :value="$options.SECONDS_IN_MINUTE">хв</option>
						<option :value="$options.SECONDS_IN_HOUR">год</option>
						<option :value="$options.SECONDS_IN_DAY">днів</option> 
					</Field>
				</div>
			</div>

			<Field
				:name="`${Station.passportKeys.notificationDistributionLists.self}.${Station.passportKeys.notificationDistributionLists.connection}`"
				type="checkbox"
				id="allert-on-connection"
				class="form-check-input col-auto"
				:value="true"
				:uncheckedValue="false"
			/>
			<label for="allert-on-connection" class="form-check-label mx-2 my-0 col-auto">
				Сповіщати про втрату зв'язку
			</label>
		</div>

		<div class="col-12 col-xl-6">
			<div class="bg-body border-radius px-3 py-2">
				<span class="form-text fst-italic">
					<b>Графік опитування матиме вигляд:</b><br>
					<span
						v-for="(point, index) in buildCalendarForStation(values).slice(0, $options.SURVEY_CALENDAR_SHOW_COUNT - 1)"
						:key="index"
					>
						{{ point }}&nbsp;
					</span>
					<span
						v-if="buildCalendarForStation(values).length > $options.SURVEY_CALENDAR_SHOW_COUNT"
						class="text-nowrap"
					>
						...&nbsp;{{ buildCalendarForStation(values)[buildCalendarForStation(values).length - 1] }}
						&nbsp;&nbsp;&nbsp;(всього&nbsp;{{ buildCalendarForStation(values).length }})
					</span>
				</span>
			</div>
		</div>
	</div>

	<div class="form-row row m-0 p-0 g-3">
		<div class="col-12 col-xl-6">
			<label>{{ Station.settingNames[Station.passportKeys.potentialSource] }}</label>
			<Field
				:name="Station.passportKeys.potentialSource"
				as="select"
				class="form-control form-control-sm"
				:class="{ 'is-invalid': errors[Station.passportKeys.potentialSource] }"
			>
				<option value="" disabled>Натисніть щоб обрати</option>
				<template v-for="[key, value] of Object.entries(Station.potentialSourceNames)" :key="key">
					<option :value="key">{{ value }}</option>
				</template>
			</Field>
			<div class="invalid-feedback">
				{{ errors[Station.passportKeys.potentialSource] }}
			</div>
		</div>

		<div class="col-12 col-xl-6">
			<div class="bg-body border-radius px-3 py-2">
				<p class="form-text fst-italic paragraph-indent">
					Джерело значення потенціалу для: таблиці та плиток станцій, телеконтролю станції, графіків в розділах телеконтроль, захищеність.
				</p>
			</div>
		</div>
	</div>

	<div class="row form-row m-0 p-0 my-1">
		<p :class="feedbackPromtClass">
			&nbsp;{{ feedbackPromt }}
		</p>
	</div>
	
	<div class="row form-row m-0 p-0 mt-1 mb-3">
		<div class="form-group col-auto me-0">
			<button
				ref="submitButtonRef"
				type="submit"
				class="btn btn-primary btn-sm"
				:disabled="!meta.valid || !meta.dirty || isSubmitting"
			>
				Записати
			</button>
		</div>
	</div>
	<!-- <pre>Errors: {{ errors }}</pre> -->
	<!-- <pre>Values: {{ values }}</pre> -->
	<!-- <pre>{{ console.log('Meta', meta) }}Meta: <br> touched: {{ meta.touched }} <br> pending: {{ meta.pending }} <br> valid: {{ meta.valid }} <br> dirty: {{ meta.dirty }} </pre> -->
</fieldset>
</Form>
</template>




<script>
import { useStationsStore } from '@/stores/StationsStore.js'
import { useAccontStore } from '@/stores/AccountStore.js'
// Validation
// https://jasonwatmore.com/post/2020/10/01/vue-3-veevalidate-form-validation-example
import { Form, Field } from 'vee-validate'
// https://github.com/jquense/yup/tree/a58f02d2f6164c46a9757a818eebac582f7a441c#boolean
import * as Yup from 'yup';
import { SettingsSchema } from "@/models/objectPrototype.js"
import { Station } from '@/models/station'
import {
	parseTimeDate,
	parseApiTimeDate,
	convertToApiTimeDate,

} from '@/api/api.js'
import {
	capitalizeFirstLetter,
	dateTimeToString,
	buildCalendar,
} from '@/helpers.js'


export default {
	SECONDS_IN_YEAR: 31536000,
	SECONDS_IN_MONTH: 2592000,
	SECONDS_IN_WEEK: 604800,
	SECONDS_IN_DAY: 86400,
	SECONDS_IN_HOUR: 3600,
	SECONDS_IN_MINUTE: 60,

	SURVEY_CALENDAR_SHOW_COUNT: 16,

	requiredPromt: 'Обов\'язкове поле',
	overMinLenPromt: 'Довжина меньше мінімальної',
	overMaxLenPromt: 'Довжина більше максимальної',
	overMinPromt: 'Значення меньше мінімального',
	overMaxPromt: 'Значення більше максимального',
	onlyIntegersPromt: 'Має бути цілим числом',
	onlyPositivePromt: 'Має бути натуральним числом',
	wrongInputPromt: 'Не відповідає вимогам',

	components: {
		Form,
        Field,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	emits: {
		saveFunction: (f) => typeof f === 'function',
		saveFunctionActive: (f) => typeof f === 'boolean',
	},

	setup() {
		const stationsStore = useStationsStore()
		const accountStore = useAccontStore()

		return {
			stationsStore,
			accountStore,
			Station,
			capitalizeFirstLetter,
			parseTimeDate,
			dateTimeToString,
		}
	},

	data() {
		const schema = SettingsSchema.shape({
			survey_period: Yup.number()
				.typeError(this.$options.wrongInputPromt)
				.required(this.$options.requiredPromt)
				.integer(this.$options.onlyIntegersPromt)
				.positive(this.$options.onlyPositivePromt)
				.when('surveyPeriodMultiplier', (multiplier, schema) => {
					// If no multiplier
					if (!multiplier) {
						return schema
							.min(10, this.$options.overMinPromt)
							.max(86400, this.$options.overMaxPromt)
					}
					
					const minValue = Math.floor(10 / multiplier[0])
					const maxValue = Math.floor(86400 / multiplier[0])

					return schema
						.min(minValue, this.$options.overMinPromt)
						.max(maxValue, this.$options.overMaxPromt)
				}),

			surveyPeriodMultiplier: Yup.number()
				.integer(this.$options.onlyIntegersPromt)
				.positive(this.$options.onlyPositivePromt),

			[Station.passportKeys.potentialSource]: Yup.string()
				.typeError(this.$options.wrongInputPromt),
        });

		return {
			// Form
			schema,
			formMeta: {},
			isSubmittingForm: false,

			// Feedback promt
			feedbackPromtClass: '',
			feedbackPromt: '',
		}
	},

	watch: {
		formMeta(newMeta) {
			if (newMeta) {
				this.$emit('saveFunctionActive', newMeta.valid && newMeta.dirty && !this.isSubmittingForm);
				// console.log('meta change', newMeta, !newMeta.valid || !newMeta.dirty || this.isSubmittingForm)
			}
		},
	},

	created() {},

	mounted() {
		// Emit function
		this.$emit('saveFunction', this.submitButtonClick)
	},

	methods: {
		onSubmit(values) {
			// Add curent user as passport updator
			values[Station.passportKeys.updateBy] = this.accountStore.userId

			// Convert time fields to datetime for api compatibility
			//
			// station survey_start_time
			let time = values[Station.passportKeys.surveyStartTime]
			if (time) {
				let date = new Date()
				date.setHours(time?.slice(0,2), time?.slice(3,5), time?.slice(6,8), 0)
				values[Station.passportKeys.surveyStartTime] = convertToApiTimeDate(date)
			} else {
				let date = new Date()
				date.setHours(0, 0, 0, 0)
				values[Station.passportKeys.surveyStartTime] = convertToApiTimeDate(date)
			}
			// Enumerate all schema. Translate all date to API datetime
			for (const [key, value] of Object.entries(this.schema.fields)) {
				if (value.type == 'date' && values[key]) {
					values[key] = convertToApiTimeDate(values[key])
				}

				// Delete all empty strings
				if (value.type == 'string' && values[key]?.length == 0) {
					delete values[key]
				}

				// Delete all unefined fields
				if (values[key] === undefined) {
					delete values[key]
				}
			}

			// Parse notification_distribution_lists and convert to passport format
			let notificationDistributionLists = this.station?.passport.get(Station.passportKeys.notificationDistributionLists.self)
			if (!notificationDistributionLists) {
				this.station.passport.set(Station.passportKeys.notificationDistributionLists.self, new Object())
				notificationDistributionLists = this.station.passport.get(Station.passportKeys.notificationDistributionLists.self)
			}
			//console.log('Notif', notificationDistributionList)
			for (const [key, value] of Object.entries(values[Station.passportKeys.notificationDistributionLists.self])) {
				const userId = this.accountStore.userId
				
				// If notification is enable
				if (value) {
					// if no list at all
					if (notificationDistributionLists[key] === undefined) {
						notificationDistributionLists[key] = []
					}
					// If current user is not in distribution notifications list
					if (!notificationDistributionLists[key].includes(userId)) {
						notificationDistributionLists[key].push(userId)
					}
				} else {
					// If current user is in distribution notifications list
					if (notificationDistributionLists[key] !== undefined
						&& notificationDistributionLists[key].includes(userId)
					) {
						const index = notificationDistributionLists[key].indexOf(userId);
						notificationDistributionLists[key].splice(index, 1)
					}
				}
			}
			// Add notification_distribution_lists to form values
			values[Station.passportKeys.notificationDistributionLists.self] = notificationDistributionLists

			// Translate survey period
			// For station
			values[Station.passportKeys.surveyPeriod] = Math.floor(
				values[Station.passportKeys.surveyPeriod] * values['surveyPeriodMultiplier']
			)
			delete values['surveyPeriodMultiplier']

			this.stationsStore.updatePasport(
				(result) => {
					if (result) {
						this.printHint('Паспорт успішно оновлено.')
						// Update passport
						this.stationsStore.readPassport(
							undefined,
							this.stationId
						)
					} else {
						this.printErr('Сервер відхилив запит.')
					}
				},
				this.stationId,
				values,
			)
		},

		submitButtonClick() {
			this.$refs.submitButtonRef.click()
		},

		buildCalendarForStation(formValues) {
			if (!formValues[Station.passportKeys.electricMeter.surveyPeriod]) {
				return buildCalendar(undefined, undefined)
			}

			const period = formValues[Station.passportKeys.electricMeter.surveyPeriod]
				* formValues.surveyPeriodMultiplier

			return buildCalendar(period, undefined)
		},

		printHint (msg) {
			this.feedbackPromtClass = "text-success"
			this.feedbackPromt = msg
		},

		printErr (msg) {
			this.feedbackPromtClass = "text-danger"
			this.feedbackPromt = msg
		},
	},

	computed: {
		station() { return this.stationsStore.station(this.stationId) },

		isFormEnabled() { return this.accountStore.permissions.includes('manage_stations') },

		formValues() {
			const passport = Object.fromEntries(
				this.stationsStore.station(this.stationId).passport
			)
			const form = {}

			form[Station.passportKeys.ip] = passport[Station.passportKeys.ip]

			// Translate datetime to time fields
			//
			// station survey_start_time
			let time = passport[Station.passportKeys.surveyStartTime]
			if (time) {
				time = parseApiTimeDate(time)
				form[Station.passportKeys.surveyStartTime] = 
					`${String(time.getHours()).padStart(2, '0')}:${String(time.getMinutes()).padStart(2, '0')}:${String(time.getSeconds()).padStart(2, '0')}`
			}

			// Calculate survey time multiplier
			// For station
			if (passport[Station.passportKeys.surveyPeriod] >= this.$options.SECONDS_IN_DAY) {
				form['surveyPeriodMultiplier'] = this.$options.SECONDS_IN_DAY
			} else if (passport[Station.passportKeys.surveyPeriod] >= this.$options.SECONDS_IN_HOUR) {
				form['surveyPeriodMultiplier'] = this.$options.SECONDS_IN_HOUR
			} else if (passport[Station.passportKeys.surveyPeriod] >= this.$options.SECONDS_IN_MINUTE) {
				form['surveyPeriodMultiplier'] = this.$options.SECONDS_IN_MINUTE
			} else {
				form['surveyPeriodMultiplier'] = 1
			}
			form[Station.passportKeys.surveyPeriod] = Math.floor(
				passport[Station.passportKeys.surveyPeriod] / form['surveyPeriodMultiplier']
			)

			// If notification lists is present in passport
			if (passport[Station.passportKeys.notificationDistributionLists.self]) {
				// Parse notification Distribution Lists
				const parsedNotificationsList = {}
				for (const [key, value] of Object.entries(passport[Station.passportKeys.notificationDistributionLists.self])) {
					// Add notification flag to parsed lists
					parsedNotificationsList[key] = value.includes(this.accountStore.userId)
				}
				form[Station.passportKeys.notificationDistributionLists.self] = parsedNotificationsList
			}

			form[Station.passportKeys.potentialSource] = passport[Station.passportKeys.potentialSource]

			return form
		},
	},
}
</script>




<style scoped>
/* Remove arrows from input Chrome, Safari, Edge, Opera */
input.no-arrow::-webkit-outer-spin-button,
input.no-arrow::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Remove arrows from input Firefox */
input[type=number].no-arrow {
	appearance: textfield;
	-moz-appearance: textfield;
}

/* Style for input if it is not match register value */
.not-match-register {
	border-color: rgb(11, 94, 215);
	color: rgb(11, 94, 215);
}
</style>